var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',[_c('loader',{staticClass:"py-5",attrs:{"text":`Logging you out`}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }